import { render, staticRenderFns } from "./ProjectInfoEditButton.vue?vue&type=template&id=70b08971&"
import script from "./ProjectInfoEditButton.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports